import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import {
  ApiEventItem,
  EVENT_ACCESS_PAGE_SIZE,
  EventAccessPage,
  MyEventItem,
  PastEventTab,
} from 'src/app/types/event-access.types';

const SELLERS_PERMISSION_PATH: Readonly<Record<PastEventTab, string>> = {
  ended: 'events-past',
  inactive: 'events-inactive',
};

/** Fuentes de eventos propias de la lista por rol. Ninguna lleva `role`: no lo validan. */
@Injectable({
  providedIn: 'root'
})
export class EventAccessApiService {
  private baseUrl = `${environment.api_server}/api`;

  constructor(
    private _http: HttpClient,
    private _api: ApiService,
  ) { }

  /** Vigentes donde el usuario vende o tiene permisos explícitos (no trae jefe/admin). */
  public getMyEvents(page = 1, q?: string): Observable<EventAccessPage<MyEventItem>> {
    return this.get<MyEventItem>(`${this.baseUrl}/seller-app/my-events`, this.pageParams(page, q));
  }

  /** Pasados/inactivos con productos o permisos; trae `global_report` por evento. */
  public getSellersEventsWithPermissions(
    tab: PastEventTab,
    page = 1,
    q?: string,
  ): Observable<EventAccessPage<ApiEventItem>> {
    const url = `${this.baseUrl}/sellers/${SELLERS_PERMISSION_PATH[tab]}`;
    return this.get<ApiEventItem>(url, this.pageParams(page, q).set('with_permissions', 'true'));
  }

  private pageParams(page: number, q?: string): HttpParams {
    const params = new HttpParams()
      .set('page', String(page))
      .set('per_page', String(EVENT_ACCESS_PAGE_SIZE));
    const query = q?.trim();
    return query ? params.set('q', query) : params;
  }

  private get<T>(url: string, params: HttpParams): Observable<EventAccessPage<T>> {
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers => this._http.get<EventAccessPage<T>>(url, { headers, params }))
    );
  }
}
